import { loader } from 'graphql.macro'

export default async function exportAllPaymentsToQuickbooks ({ dataLoaders, variables }) {
  const schema = loader('./exportAllPaymentsToQuickbooks.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      id: variables.id
    }
  })
  return response.exportAllPaymentsToQuickbooks
}
